import { request } from '@/shared/api/request'

export const getEmployeeListXml = ({params}) => {
	return request({ url: 'staff/wplace/xml', method: 'POST', params })
}
